import { createFileRoute, Link } from "@tanstack/react-router";
import { posts, formatDate } from "@/lib/posts";

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "European Patent & EU Trade Mark Guides (US Filers, 2026)" },
      {
        name: "description",
        content:
          "Straight answers with real numbers: 31-month PCT deadline, EPO fees from ~$5k to grant, EUIPO filing from EUR 850, UPC opt-out rules. Written for US filers.",
      },
      {
        property: "og:title",
        content: "European Patent & EU Trade Mark Guides (US Filers, 2026)",
      },
      { property: "og:image", content: "https://bauerip.com/og-us.jpg" },
      { name: "twitter:image", content: "https://bauerip.com/og-us.jpg" },
      {
        property: "og:description",
        content:
          "Straight answers with real numbers: 31-month PCT deadline, EPO fees from ~$5k to grant, EUIPO filing from EUR 850, UPC opt-out rules. Written for US filers.",
      },

      { property: "og:url", content: "https://bauerip.com/blog" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://bauerip.com/blog" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://bauerip.com",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Blog",
              item: "https://bauerip.com/blog",
            },
          ],
        }),
      },
    ],
  }),

  component: BlogIndex,
});

function BlogIndex() {
  return (
    <section className="mx-auto max-w-6xl px-6 py-20 md:py-24">
      <p className="eyebrow mb-4">IP Insights</p>
      <h1 className="font-serif text-4xl md:text-5xl text-foreground leading-tight max-w-3xl">
        Free guides on European patents, EU trade marks and US expansion.
      </h1>

      <div className="mt-12 md:mt-16 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <article
            key={post.slug}
            className="group bg-background rounded-2xl p-6 border border-border hover:border-accent transition-all hover:shadow-lg flex flex-col"
          >
            <div className="flex items-center justify-between mb-4">
              <span className="eyebrow text-xs">{post.category}</span>
              <time className="text-xs text-muted-foreground" dateTime={post.date}>
                {formatDate(post.date)}
              </time>
            </div>
            <h2 className="font-serif text-xl md:text-2xl text-foreground leading-snug flex-1">
              <Link
                to="/blog/$slug"
                params={{ slug: post.slug }}
                className="hover:text-accent-text transition-colors"
              >
                {post.title}
              </Link>
            </h2>
            <p className="mt-4 text-muted-foreground leading-relaxed text-sm">
              {post.excerpt}
            </p>
            <Link
              to="/blog/$slug"
              params={{ slug: post.slug }}
              className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-foreground group-hover:gap-3 transition-all"
            >
              Read article <span className="text-accent-text">→</span>
            </Link>
          </article>
        ))}
      </div>
    </section>
  );
}
